<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Forms Management Inventory</h3>
    @if (canCreateFormManagement()) {
    <div class="card-actions">
      <button (click)="createNewFormsManagement()" mat-flat-button color="primary" type="button">
        <mat-icon>add</mat-icon> Add Form
      </button>
      @if (isAdminOrSystem()) {
      <button (click)="navigateToBulkUpload()" mat-flat-button color="primary" type="button">
        <mat-icon>upload_file</mat-icon> Bulk Upload
      </button>
      }
    </div>
    }
  </div>
  <div class="pcs-header mt-3">
    <app-search-sort [searchControl]="searchControl" [sortForm]="sortForm" [sortOptions]="sortOptions"
      (apply)="setSortField()" (close)="resetSortField()"></app-search-sort>
    @if (canAddColumns) {
    <button mat-stroked-button [matMenuTriggerFor]="customColumnsMenu" class="custom-columns-btn">
      <mat-icon>view_column</mat-icon>
      Custom Columns
    </button>

    <mat-menu #customColumnsMenu="matMenu" class="custom-columns-menu">
      <div class="custom-columns-panel" (click)="$event.stopPropagation()">
        <div class="panel-header">
          <div>
            <div class="panel-title">Custom Columns</div>
            <div class="panel-subtitle">Show/hide and review field settings</div>
          </div>
        </div>

        @for (col of customColumns; track col.id) {
        <div class="custom-column-row">
          <div class="column-info">
            <div class="column-name-row">
              <span class="column-name">{{ col.fieldLabel }}</span>

            </div>
            <span class="type-pill">{{ col.dataType }}</span>
          </div>

          <div class="column-toggles">
            <mat-slide-toggle [checked]="col.isVisibleInGrid" (change)="toggleCustomColumnGrid(col)">
              Grid
            </mat-slide-toggle>

            <mat-slide-toggle [checked]="col.isVisibleInForm" (change)="toggleCustomColumnForm(col)">
              Form
            </mat-slide-toggle>
          </div>
        </div>
        }

        @if (!customColumns.length) {
        <div class="empty-state">
          No custom columns added yet.
        </div>
        }
      </div>
    </mat-menu>}
  </div>
  <div class="pro-card column">
    <app-ag-grid-wrapper [data]="rowData" [columns]="columnDefs" (ready)="onGridReady($event)" />
    <mat-paginator #paginator [selectConfig]="{ panelClass: 'mat-paginator-select-options' }" [length]="totalCount"
      [pageIndex]="currentPage" [pageSize]="pageSize" [pageSizeOptions]="pageSettings.pageSizeOptions"
      [disabled]="isLoading"
      (page)="handlePageEvent($event)" aria-label="Select page">
    </mat-paginator>
  </div>
</div>